import { NzMessageService } from "ng-zorro-antd/message";
import { WebHookCommonServices } from "../../webhook-services/webhook-commom.services";
import { LanguageServices } from "src/app/services/LanguageServices";
import { NZ_MODAL_DATA, NzModalService } from "ng-zorro-antd/modal";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NzTableComponent, NzTableFilterValue, NzTableQueryParams } from "ng-zorro-antd/table";
import { WebhookField } from "../../webhook-interfaces/configuration";
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import * as ace from "ace-builds";
import { GlobalErrorHandler } from "src/app/services/GloabalErrorHandler.services";

@Component({
    selector: 'webhook-log',
    templateUrl: './webhook-debug-log.component.html',
    styleUrl: './webhook-debug-log.component.scss',
    standalone: false
})
export class WebhookDebugLogComponent implements OnInit, AfterViewInit{
    

    constructor(
        private whServices:WebHookCommonServices,
        private uas:UserAuthenticationServices,
        private fb:FormBuilder,
        private cd:ChangeDetectorRef,
        @Inject(NZ_MODAL_DATA) public nzData
    ) {}
    
    hidelogFace= true;
    jsonMode = false;
    selected = null;


    async refreshDataLog(){
        this.loadingDataLog = true;
        this.selected['DATALOG'] = null;
        
        this.loadFromServerByIdJob( this.selected['_id']).then(async data=>{
            
            const index = this.logs.findIndex(i => i.IDJOB ===  this.selected['IDJOB'] && i.SEQUENCE ===  this.selected['SEQUENCE']);
            
            if (index !== -1) {
                this.logs[index] = { ...data };
                // força detecção de mudança se necessário
                this.logs = [...this.logs];
            }
            this.selected = data;
            
            if (  this.selected['UPLOADURL']!= null && ( this.selected['DATALOG']==null ||  this.selected['DATALOG']=='') ){
                this.loadingDataLog = true;
                await this.whServices.getDataLog( this.selected['UPLOADURL']).then(data=>{
                    this.selected['DATALOG'] = data;
                    
                    this.cd.detectChanges();
                    this.loadingDataLog = false;
                }).catch(error=>{
                    this.loadingDataLog = false;
                });
                
            }else{
                await this.whServices.getDataLogRuntime( this.selected['IDJOB'],  this.selected['SEQUENCE']).then(data=>{
                     this.selected['DATALOG'] = data;
                    
                    this.loadingDataLog = false;
                }).catch(error=>{
                    this.loadingDataLog = false;
                });
            }

            this.loadingDataLog = false;
        }).catch(error=>{
            this.loadingDataLog = false;
        });
        
    }

    loadFromServerByIdJob(id:string): Promise<any>{
        return new Promise((resolve,reject)=>{
            this.whServices.loadLogByIdJob(id).then(data=>{
                resolve(data);
            }).catch(error=>{
                reject(error);
            });
        });
        
    }

    async editVariableDoubleClick(line:object){
        this.selected = null;
        this.hidelogFace = false;
        this.selected = line;
        this.refreshDataLog();        
    }

    ngAfterViewInit(): void {
    }
    
    editorOptions = {
        fontSize: '14px',
        showPrintMargin: false,
        highlightActiveLine: true,
        showGutter: true
    };

    
    loading = false;
    total:number = 0;
    logs:any[] = [];
    pageIndex:number = 1;
    pageSize:number = 10;
    idconf;
    visible:{
            IDJOB:boolean,
            SEQUENCE:boolean,
            CODECOMPANY:boolean,
            TYPEEXEC:boolean,
            STATUS:boolean,
            MESSAGE:boolean,
            DHINI:boolean,
            DHEND:boolean
    } = {
        IDJOB:false,
        SEQUENCE:false,
        CODECOMPANY:false,
        TYPEEXEC:false,
        STATUS:false,
        MESSAGE:false,
        DHINI:false,
        DHEND:false
    }


    IDJOBFIELD:WebhookField = {
        field:'IDJOB',
        label:'workflow.log.idjob',
        placeholder:'workflow.log.idjob',
        type:'text',        
    };

    MESSAGEFIELD:WebhookField = {
        field:'MESSAGE',
        label:'workflow.log.message',
        placeholder:'workflow.log.message',
        type:'text',        
    };

    SEQUENCEFIELD:WebhookField = {
        field:'SEQUENCE',
        label:'workflow.log.sequence',
        placeholder:'workflow.log.sequence',
        type:'number',        
    };

    CODECOMPANYFIELD:WebhookField = {
        field:'CODECOMPANY',
        label:'workflow.log.codecompany',
        type:'search',
        
        searchProperties:{
            entityName:'Mktpcompanies',
            fields:{
                keyField:'CODECOMPANY',
                valueField:'NAME'
            }
        },
        showKey:true        
    }

    STATUSFIELD:WebhookField = {
        field:'STATUS',
        label:'workflow.log.status',
        placeholder:'workflow.log.status',
        type:'select',
        options:[
            {
                label:"workflow.log.execute",
                value:"0"
            },
            {
                label:"workflow.log.executing",
                value:"1"
            },
            {
                label:"workflow.log.success",
                value:"2"
            },
            {
                label:"workflow.log.error",
                value:"3"
            }
        ]        
    };

    TYPEEXECFIELD:WebhookField = {
        field:'TYPEEXEC',
        label:'workflow.log.typeexec',
        placeholder:'workflow.log.typeexec',
        type:'select',
        options:[
            {
                label:"workflow.log.normal",
                value:"NORMAL"
            },
            {
                label:"workflow.log.debug",
                value:"DEBUG"
            },
            {
                label:"workflow.log.online",
                value:"ONLINE"
            }
        ]        
    };
    
    DHINIFIELD:WebhookField = {
        field:'DHINI',
        label:'workflow.log.dhini',
        placeholder:'workflow.log.dhini',
        type:'date'
    }
        
    DHENDFIELD:WebhookField = {
        field:'DHEND',
        label:'workflow.log.dhend',
        placeholder:'workflow.log.dhend',
        type:'date'
    }

    filterGroup:FormGroup;
    @ViewChild('logTable',{ static: false }) table:NzTableComponent<any>;
    currentFilter: {
            key: string;
            value: NzTableFilterValue
        }[]=[];
    

    ngOnInit(): void {
        this.idconf = this.nzData.flowData.idconf;

        //this.loadFromServer(this.pageIndex, this.pageSize, null, null, []);

        this.filterGroup = this.fb.group({
            IDJOB:[''],
            SEQUENCE:[''],
            CODECOMPANY:[''],
            MESSAGE:[''],
            TYPEEXEC:[''],
            STATUS:[''],
            DHINI:[''],
            DHEND:['']
        });
    }


    ngOnDestroy(){
        this.whServices.cancelLoading();
    }

    loadFromServer(
        pageIndex: number,
        pageSize: number,
        sortField: string | null,
        sortOrder: string | null,
        filter: Array<{ key: string; value: string[] }>
        ): void {
            this.loading = true;
            this.logs = [];
            this.whServices.loadLog(this.idconf,((pageIndex -1 )*pageSize), pageSize, sortField, sortOrder, filter,this.uas).then((data:object[]) => {
                
                this.loading = false;
                this.total = data == null || data.length == 0 ? 0 : data[0]['CONTADOR'];
                this.logs = data || [];
            }, error => {
                this.loading = false;   
                GlobalErrorHandler.showError(error);
            });

        }

    loadingDataLog = false;


    refreshData():void{
        let param:NzTableQueryParams = { 
            pageSize:this.table.nzPageSize,
            pageIndex: this.table.nzPageIndex,
            sort: [],
            filter: this.currentFilter
        }
        this.table.nzQueryParams.emit(param);
    }

    onQueryParamsChange(params: NzTableQueryParams): void {
            
            let { pageSize, pageIndex, sort, filter } = params;
            
            if ( this.currentFilter.length > 0 ){
                filter = this.currentFilter;
            }
            
            const currentSort = sort.find(item => item.value !== null);
            const sortField = (currentSort && currentSort.key) || null;
            const sortOrder = (currentSort && currentSort.value) || null;
            
            this.loadFromServer(pageIndex, pageSize, sortField, sortOrder, filter);
    }

    search(field: string) {
        let index = this.currentFilter.findIndex(d=>d.key==field);

        if  ( index == -1 ){
            this.currentFilter.push({
            key:field,
            value:this.filterGroup.get(field).value
            })
        }else{
            this.currentFilter.find(d=>d.key==field).value = this.filterGroup.get(field).value;
        }
        
        let param:NzTableQueryParams = { 
            pageSize:this.table.nzPageSize,
            pageIndex: this.table.nzPageIndex,
            sort: [],
            filter: this.currentFilter
        }
        this.table.nzQueryParams.emit(param);
        
        this.visible[field] = false;
        
    }

    reset(field: string) {
        this.filterGroup.get(field).setValue(null);
        let index = this.currentFilter.findIndex(d=>d.key==field);
        this.currentFilter.splice(index,1);
        this.search(field);
    }


    expandSet = new Set<number>();
    onExpandChange(id: number, checked: boolean, line:object): void {
        if (checked) {
            if ( line['UPLOADURL']!= null && (line['DATALOG']==null || line['DATALOG']=='') ){
                this.loadingDataLog = true;
                this.whServices.getDataLog(line['UPLOADURL']).then(data=>{
                    line['DATALOG'] = data;
                    this.loadingDataLog = false;
                }).catch(error=>{
                    this.loadingDataLog = false;
                });
                this.expandSet.add(id);
                
            }else{
                this.whServices.getDataLogRuntime(line['IDJOB'], line['SEQUENCE']).then(data=>{
                    line['DATALOG'] = data;
                    this.loadingDataLog = false;
                }).catch(error=>{
                    this.loadingDataLog = false;
                });
                this.expandSet.add(id);
            }
            
        } else {
            this.expandSet.delete(id);
        }
    }
    

    formatJSON(json):string{
        try{
            if ( json instanceof String){
                return JSON.stringify(JSON.parse(json.toString()),null,2);
            }else{
                return JSON.stringify(json,null,2);
            }
            
        }catch(erro){
            return erro;
        }
    }

    toJSON(json):string{
        try{
            if ( json instanceof String){
                return JSON.parse(json.toString());
            }else{
                return JSON.parse(json);
            }
            
        }catch(erro){
            return erro;
        }
    }

}